// If passed object is function, call the function with the passed value
// Otherwise, simply return the object without doing anything to it
export default (objectOrFunction: any, value: any) => {
  return typeof objectOrFunction === 'function'
    ? objectOrFunction(value)
    : objectOrFunction
}
